import {
  CustomerContractSnapshotTypes,
  CustomerContractSnapshotFormInput
} from "@graphql";

export type FormData = CustomerContractSnapshotFormInput;

export const initialValues: FormData = {
  _id: null,
  customerContractId: null,
  customerId: null,
  invoiceMarking: null,
  consultantId: null,
  contactPersonId: null,
  responsiblePersonId: null,
  parentId: null,
  type: CustomerContractSnapshotTypes.Framework
};
